export default {
  exportLoading: false,
  loading: false,
  logsUser: [],
  totalLogsUser: 0,
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-analytic/features/logs/pages/user/store/states.js